import React from "react";
import classnames from "classnames";
import { connect } from "react-redux";
import map from "lodash/map";
import find from "lodash/find";

import {
    licenses,
    licensesDisplay,
    constToCSS,
    singleIconPricePlaceholder
} from "../../reducers/download";
import { ALACARTE_TYPE } from "../../reducers/stripe";

import "intl";
import "intl/locale-data/jsonp/en.js";

let formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2
});

const LicenseDisplay = props => {
    let { license, current } = props;

    let licenseDisplay = licensesDisplay[license];

    if (!licenseDisplay) {
        return null;
    }

    let licenseClass = classnames(
        "license-choice",
        `license-choice-${constToCSS(license)}`,
        {
            current: current == license,
            "blue-choice": license == licenses.ROYALTY_FREE
        }
    );

    let notes = map(licenseDisplay.notes, (note, i) => {
        let className, text;
        if (note.className) {
            className = note.className;
            text = note.text;
        } else {
            text = note;
        }

        text = text.replace(
            singleIconPricePlaceholder,
            formatter.format(props.singleIconPriceCents / 100)
        );

        className = classnames(className, {
            "with-class": !!className
        });
        return (
            <li key={i} className={className}>
                <span>{text}</span>
            </li>
        );
    });

    let action;
    if (props.onSelect) {
        action = props.onSelect.bind(null, licenses[license]);
    }

    let headerClass = classnames(
        "license-icon",
        `license-${constToCSS(license)}`
    );
    return (
        <li className={licenseClass} onClick={action}>
            <div className="text-wrapper">
                <h2 className={headerClass}>{licenseDisplay.title}</h2>
                <ul className="license-choice-notes">{notes}</ul>
            </div>
        </li>
    );
};

function mapStateToProps(state, ownProps) {
    let { stripe } = state;
    let alacartePurchase = find(stripe.purchaseTypes, { type: ALACARTE_TYPE });

    return {
        singleIconPriceCents: alacartePurchase.price
    };
}

export default connect(mapStateToProps, {})(LicenseDisplay);
